<template>
  <v-container class="pa-0 ma-0">
    <v-row class="pa-0 ma-0">
      <v-col class="pa-0 ma-0 pa-2">
        <div v-if="label" class="mb-3">{{label}}</div>
        <v-chip label v-for="day in days" :key="day.vl"
          @click="click(day)"
          :input-value="day.active"
          class="weekday d-flex d-inline-flex mr-2 mb-1">
          {{day.lbl}}
        </v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
    },
    label: {
      type: String,
    },
  },
  data: () => ({
    days: [
      { vl: '1', lbl: 'D', active: true },
      { vl: '2', lbl: 'S', active: true },
      { vl: '3', lbl: 'T', active: true },
      { vl: '4', lbl: 'Q', active: true },
      { vl: '5', lbl: 'Q', active: true },
      { vl: '6', lbl: 'S', active: true },
      { vl: '7', lbl: 'S', active: true },
    ],
    selected: [],
  }),
  computed: {
  },
  created() {
    if (this.value && this.value.length > 0) {
      this.value.forEach((el) => {
        this.days[el - 1].active = true;
      });
    }

    // (1 = Domingo, 2 = Segunda, 3 = Terça, 4 = Quarta, 5 = Quinta, 6 = Sexta, 7 = Sábado)
    this.handleSelected();
  },
  methods: {
    click(day) {
      const foundIndex = this.days.findIndex(x => x.vl == day.vl);
      this.days[foundIndex].active = !day.active;

      this.handleSelected();

      this.$emit('input', (this.selected && this.selected.length > 0) ? this.selected : null);
    },
    handleSelected() {
      this.selected = [];
      this.days.forEach((el) => {
        if (el.active === true) {
          this.selected.push(el.vl);
        }
      });
    },
  },
  watch: {
    value(vl) {
      if (this.value && this.value.length > 0) {
        this.value.forEach((el) => {
          this.days[el - 1].active = true;
        });
      }
    },
  },
};
</script>

<style scoped>
  span.weekday.v-chip.v-chip--active {
    background-color: var(--v-primary-base) !important;
    color: var(--v-secondary-base) !important;
  }
</style>
